import { theme } from "@Definitions/Styled";
import { Box, Grid, styled, Typography } from "@mui/material";
import { grid } from "@mui/system";

export const StyledCategoryStand = styled(Box)`
  margin-top: 0.1rem;
  height: fit-content;
  white-space: nowrap;
  background-color: ${(props: { color: string; background: string }) =>
    props.background};
  border-radius: 3px;
`;
export const StyledIcon = styled("img")`
  margin: 0.7rem 0.5rem 0.1rem 0.7rem;
  width: 40px;
  height: 50px;
`;
export const StyledName = styled(Typography)`
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  font-size: 1.2rem !important;
  text-transform: uppercase;
  font-weight: 600;
  flex: 1;
  letter-spacing: 0;
  margin: 1rem 0;
`;
export const StyledCategoryTab = styled(Box)`
  display: inline-block;
  margin: 0.2rem 0.5rem 1.1rem 0.5rem;
  padding: 0.2rem 0.5rem;
  border-radius: 2px;
  box-shadow: 0px 5px 3px -2px rgb(0 0 0 / 20%),
    4px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  background: ${(props) => props.theme.palette.secondary.light};
  cursor: pointer;
  ${theme.breakpoints.down("sm")} {
    margin: 0.2rem 0.5rem 0.5rem 0.5rem;
    padding: 0 0.5rem;
  }
`;

export const StyledTypography = styled(Typography)`
  font-weight: 700;
  line-height: 0.5;
  font-family: "Gotham-xLight";
`;
export const StyledTypographyProductName = styled(Typography)(
  ({ theme }) => `
  display:flex;
  font-weight: 700;
  margin:1rem 0 0 0;
  text-transform: uppercase;
  lineHeight: 1.5;
  font-family: Gotham-light;
  overflow: hidden;
  webkitBoxOrient: vertical;
  display: -webkit-box;
  webkitLineClamp: 2;
  cursor: pointer;
   ${theme.breakpoints.down("sm")}{
     flex-direction:column;
     margin:0.6rem 0 0 0;
    }
  `
);
export const styledProductImage = styled("img")({
  borderRadius: "10px",
  cursor: "pointer",
  display: "block",
});

export const StyledHeadingWithGradientunderline = styled(Typography)(`
  text-transform: uppercase;
  text-align: center;
  position: relative;
  margin:0.8rem 0;
  &:before{
    content: "";
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    height: 1px;
    border-radius: 1px;
    background:linear-gradient(90deg, hsla(41, 100%, 50%, 1) 0%, hsla(162, 100%, 35%, 1) 48%, hsla(202, 100%, 46%, 1) 100%);
  }
  ${theme.breakpoints.down("sm")}{
    margin:0.5rem 0;
  }
`);
